import axios from './lib/axios.js'; // This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs

var Axios = axios.Axios,
    AxiosError = axios.AxiosError,
    CanceledError = axios.CanceledError,
    isCancel = axios.isCancel,
    CancelToken = axios.CancelToken,
    VERSION = axios.VERSION,
    all = axios.all,
    Cancel = axios.Cancel,
    isAxiosError = axios.isAxiosError,
    spread = axios.spread,
    toFormData = axios.toFormData,
    AxiosHeaders = axios.AxiosHeaders,
    HttpStatusCode = axios.HttpStatusCode,
    formToJSON = axios.formToJSON,
    mergeConfig = axios.mergeConfig;
export { axios as default, Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, mergeConfig };